import { CartItem } from "./cart";

export enum IStatus {
  Pending = "Pending",
  Shipped = "Shipped",
  Cancelled = "Cancelled",
  Delivered = "Delivered",
}
export enum IPaymentStatus {
  Pending = "Pending",
  Paid = "Paid",
  Refunded = "Refunded",
}
export interface IShippingAddress {
  street: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}
export interface IOrder {
  _id?: string;
  userId: string;
  products: CartItem[];
  shippingAddress?: IShippingAddress;
  totalAmount?: number;
  status?: IStatus;
  paymentStatus?: IPaymentStatus;
}
